/**
 * ContactMap section
 */
(function contactMapFrontend($) {
	$(document).on('cms.ready', ready);

	function ready() {
		var logged_in = $('body.logged-in').length;

		if (logged_in) {
			$(document).on('cms.intersect', '.sectionContactMap', function (evt, entry, $elm) {
				setupSection(0, $elm);
			});
		}

		$('.sectionContactMap').each(setupSection);
	}

	function setupSection(i, elm) {
		var $elm = $(elm);
		if ($elm.data('contact-map-ready')) return;
		$elm.data('contact-map-ready', true);

		if (!window.Contenda || !Contenda.company) return;

		Contenda.company.fillContact($elm);
		$elm.find('.js-map-embed').attr('src', Contenda.company.mapsEmbedUrl());

		var address = Contenda.company.addressLines();
		var hours = Contenda.company.hoursList();
		var status = Contenda.company.openStatus();

		$elm.find('.js-open-status').toggleClass('is-open', status.open);
		$elm.find('.js-open-status-text').text(status.text);

		$elm.find('.js-address-text').text([address.street, (address.zip + ' ' + address.city).trim()].filter(Boolean).join(' · '));
		$elm.find('.js-cvr-label').text(address.cvr ? 'Adresse · CVR ' + address.cvr : 'Adresse');
		$elm.find('.js-maps-link').attr('href', Contenda.company.mapsUrl());

		var $list = $elm.find('.js-hours-list').empty();
		hours.forEach(function (day) {
			var $li = $('<li></li>').toggleClass('is-today', day.today);
			$li.append($('<span></span>').text(day.label));
			$li.append($('<span class="contact-map__time"></span>').text(day.value));
			$list.append($li);
		});
	}
})(jQuery);
